module.exports = __webpack_public_path__ + "media/assets/img/deny-designs-logo-static-1-75c35c85e58f8489bff441608f8b53f9.jpg";